import React, { useState } from "react";
import Button from "components/atoms/Button";
import InputSelect from "components/atoms/InputSelect";
import { errorMessages } from "services/StandardTreatment";

export const REGION_MODAL_ID = "editRegionModal";

// Modal multi-select provinsi untuk satu region.
// Province milik region lain tetap bisa dipilih -> dipindah ke region ini.
const EditRegionModal = ({ region, provinces, regions, onSubmit }) => {
  const regionOfProvince = {};
  (regions || []).forEach((r) => {
    (r.provinces || []).forEach((p) => {
      regionOfProvince[p.id] = r.id;
    });
  });

  const options = (provinces || []).map((p) => {
    const owner = regionOfProvince[p.id];
    const isOther = owner && String(owner) !== String(region?.id);
    return {
      label: isOther ? `${p.name} (Region ${owner})` : p.name,
      value: String(p.id),
    };
  });

  const initialSelected = options.filter((o) =>
    (region?.provinces || []).some((p) => String(p.id) === o.value)
  );

  const [selected, setSelected] = useState(initialSelected);
  const [serverErrors, setServerErrors] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setServerErrors([]);
    setSubmitting(true);
    onSubmit((selected || []).map((o) => o.value))
      .catch((err) => setServerErrors(errorMessages(err)))
      .finally(() => setSubmitting(false));
  };

  return (
    <div
      className="modal fade md-modal"
      id={REGION_MODAL_ID}
      tabIndex={-1}
      aria-labelledby={`${REGION_MODAL_ID}Label`}
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id={`${REGION_MODAL_ID}Label`}>
              Atur Provinsi — {region?.name}
            </h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Tutup">
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <form onSubmit={handleSubmit} noValidate>
            <div className="modal-body">
              {serverErrors.length > 0 && (
                <div className="mps-alert is-error" role="alert">
                  <ul className="mps-alert-list mt-0">
                    {serverErrors.map((m) => (
                      <li key={m}>{m}</li>
                    ))}
                  </ul>
                </div>
              )}
              <dl className="md-detail">
                <dt>Kode</dt>
                <dd>{region?.id}</dd>
                <dt>Region</dt>
                <dd>{region?.name}</dd>
              </dl>
              <div className="row">
                <div className="col-12 md-field" style={{ marginTop: 12 }}>
                  <InputSelect
                    label="Provinsi"
                    placeholder="Pilih provinsi"
                    isMultipleSelect
                    data={options}
                    value={selected}
                    onChange={(sel) => setSelected(sel || [])}
                  />
                  <p className="md-help">
                    Satu provinsi hanya boleh masuk satu region. Memilih provinsi
                    yang sudah ada di region lain akan memindahkannya ke region
                    ini. Kosongkan untuk mengeluarkan semua provinsi.
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <Button type="button" variant="secondary" size="normal" data-dismiss="modal">
                Batal
              </Button>
              <Button type="submit" variant="primary" size="normal" isDisabled={submitting}>
                {submitting ? "Menyimpan..." : "Simpan"}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditRegionModal;
